import {capitalize} from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import {connect} from 'react-redux';
import InfoTooltip from 'shared/components/info-tooltip';
import Stamp from 'src/components/Stamp/Stamp';
import {UserType} from 'src/types/enums';

const propTypes = {
  deadlineDay: PropTypes.number,
  deadlineMonth: PropTypes.number,
  deadlineYear: PropTypes.number,
  deadlineTerm: PropTypes.string,
  deadlineTermYear: PropTypes.number,
  userType: PropTypes.string,
};

const DeferredSubmissionPeriod = ({
  deadlineDay,
  deadlineMonth,
  deadlineYear,
  deadlineTerm,
  deadlineTermYear,
  userType,
}) => {
  const date = new Date(Date.UTC(deadlineYear, deadlineMonth - 1, deadlineDay));
  const options = {
    timeZone: 'UTC',
    month: 'numeric',
    day: 'numeric',
    year: '2-digit',
  };
  const deadline = new Intl.DateTimeFormat('en-US', options).format(date);
  const term = `${capitalize(deadlineTerm)} ${deadlineTermYear}`;
  const earningText = `Deferred to ${term} Earnings Deadline on ${deadline}`;

  return (
    <Stamp>
      <div className="college-earnings-no-earnings-status-text-content">
        {earningText}
        {userType === UserType.CC_STUDENT && (
          <InfoTooltip iconSize={14} placement="top">
            The college does not offer your preferred transfer term. The Earnings Deadline for the
            next available transfer term is applied.
          </InfoTooltip>
        )}
      </div>
    </Stamp>
  );
};

DeferredSubmissionPeriod.propTypes = propTypes;

export default connect((state) => ({
  userType: state.collegeProfile.userInfo.user,
}))(DeferredSubmissionPeriod);
